import "./MainSectionLogo.css";

function MainSectionLogo() 
{
    return (
        <section className="LogoSection">
            <div>
                <div className="MainSectionLogo">
                    <img href="#" src="../Assets/logo-banner.svg" alt="logo" />
                </div>
            </div>
        </section>
    )
} export default MainSectionLogo;